import * as mainTerms from '../../mainTerms';

const audienceDef = mainTerms.Setting.audience.default;


export const audience = {
    title: audienceDef,
    name: {
        label: audienceDef + ' 이름',
        placeholder: '이름을 입력해주세요.',
        error: {
            required: audienceDef + ' 이름을 입력해주세요',
        },
    },
    platform: {
        label: '플랫폼',
        placeholder: '플랫폼 선택',
        description: '이 ' + audienceDef + '의 대상 플랫폼을 선택하세요.',
        error: {
            required: '플랫폼을 선택해주세요',
        },
    },
    useDeepAd: {
        label: 'Deep AD 사용 여부',
        inactiveText: '미사용',
        activeText: '사용',
    },
    deepAdAudience: {
        label: 'Deep AD 오디언스',
        buttonText: 'Deep AD 오디언스 불러오기',
        column: {
            name: '오디언스 명',
            desc: '설명',
            size: '규모',
            updatedAt: '업데이트 일자',
        },
        error: {
            required: 'Deep AD 오디언스를 선택해주세요.',
        },
    },
    upload: {
        label: '파일 업로드',
        description: 'CSV 파일로 업로드 하실 수 있습니다.\n적어도 10,000개 이상의 AD ID를 포함하는 파일을 업로드 해주세요.',
        error: {
            required: '오디언스 정보 파일을 업로드해주세요.'
        }
    }
}
